import { synthesisApi } from './synthesisApi';
import { DashboardDataResponse } from '../types/dashboard';

/**
 * Obtém os dados agregados para a dashboard,
 * enviando o parâmetro cfg_id (ID da configuração/entidade).
 */
export async function getDashboardData(cfg_id: string): Promise<DashboardDataResponse> {
  const response = await synthesisApi.get<DashboardDataResponse>('/dashboard', {
    params: { cfg_id }
  });
  return response.data;
}
